/*
    Page bottom offset.
    Opposite of window.scrollY
*/
export const getPageBottomOffset = () => {
    return document.documentElement!.scrollHeight - (window.scrollY + window.innerHeight);
};
